export default "__VITE_ASSET__131dcaf9__"